// extracted by mini-css-extract-plugin
export var homeLoansContainer = "n_3";
export var title = "n_5";
export var titleContainer = "n_4";